import {
  collection,
  firestore,
  getDocs,
  orderBy,
  query,
  where
} from "../firebase";
import { stripHtmlTags } from "../utils/commonFunctions";
import { dateFormat } from "../utils/dateFormat";

export const useGenericTestimonials = (programCode, currentBrand) => {
  const normaliseBrand =
    [currentBrand[0]?.toUpperCase(), currentBrand?.substring(1)].join("") ??
    currentBrand;

  async function getTestimonialStats(programCode) {
    const testimonialRef = query(
      collection(firestore, "marketing-stories"),
      where("TestimonialProgramCode", "==", programCode),
      where("TestimonialShowOnWebsite", "==", true),
      where("TestimonialSiteBrand", "in", ["Both", "Bushwise", normaliseBrand]),
      orderBy("TestimonialDatePosted", "desc")
    );

    const testimonialsSnapshot = await getDocs(testimonialRef);

    return testimonialsSnapshot.docs.map((doc) => ({
      docId: doc.id,
      ...doc.data()
    }));
  }

  return getTestimonialStats(programCode)
    .then((results) =>
      results?.map((resItem) => ({
        title: resItem?.TestimonialParticipantName || "",
        content: stripHtmlTags(resItem?.TestimonialSummary ?? ""),
        rating: parseInt(resItem?.TestimonialRating) || 7,
        date: dateFormat(
          {
            day: "numeric",
            month: "short",
            year: "numeric"
          },
          new Date(resItem?.TestimonialDatePosted)
        ),
        ...resItem
      }))
    )
    .catch((err) => console.error("Error :: getTestimonialStats", err));
};
